import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { getUserPermissions } from '../../utils/userPermissions'

const COOKIE_KEY = 'reports_favorites'

const reports = [
  { to: '/reports/work-progress', icon: 'fa-tasks', title: 'Work progress', desc: 'Overall project welding progress by status', color: '#20a8d8', perm: 'core.work_progress.work_progress' },
  { to: '/reports/project-defectiveness', icon: 'fa-exclamation-triangle', title: 'Project defectiveness', desc: 'Defect rates and repair statistics per project', color: '#f86c6b', perm: 'core.report_project_defectiveness.report_project_defectiveness' },
  { to: '/reports/welder-defectiveness', icon: 'fa-user-times', title: 'Welder defectiveness', desc: 'Individual welder defect and repair rates', color: '#f86c6b', perm: 'core.report_welder_defectiveness.report_welder_defectiveness' },
  { to: '/reports/completion-forecast', icon: 'fa-line-chart', title: 'Completion forecast', desc: 'Projected completion dates based on current pace', color: '#4dbd74', perm: 'core.completion_forecast.completion_forecast' },
  { to: '/reports/defectiveness-trend', icon: 'fa-area-chart', title: 'Defectiveness trend', desc: 'Defect rate changes over time', color: '#ffc107', perm: 'core.defectiveness_trend.defectiveness_trend' },
  { to: '/reports/welder-benchmark', icon: 'fa-trophy', title: 'Welder benchmarking', desc: 'Performance comparison across welders', color: '#ffc107', perm: 'core.welder_benchmark.welder_benchmark' },
  { to: '/reports/inspection-backlog', icon: 'fa-hourglass-half', title: 'Inspection backlog', desc: 'Pending inspections and queue depth', color: '#63c2de', perm: 'core.inspection_backlog.inspection_backlog' },
  { to: '/reports/section-progress', icon: 'fa-th-list', title: 'Section progress', desc: 'Welding and inspection progress per section', color: '#20a8d8', perm: 'core.section_progress.section_progress' },
  { to: '/reports/wps-usage', icon: 'fa-file-text-o', title: 'WPS usage', desc: 'Welding procedure specification usage statistics', color: '#6f42c1', perm: 'core.wps_usage.wps_usage' },
  { to: '/reports/repair-analysis', icon: 'fa-wrench', title: 'Repair analysis', desc: 'Repair types, causes and resolution times', color: '#f86c6b', perm: 'core.repair_analysis.repair_analysis' },
  { to: '/reports/daily-burn-rate', icon: 'fa-fire', title: 'Daily burn rate', desc: 'Log activity heatmap — last 90 days', color: '#ff7f50', perm: 'core.daily_burn_rate.daily_burn_rate' },
  { to: '/reports/weld-lead-time', icon: 'fa-clock-o', title: 'Weld lead time', desc: 'Avg time from WPS assignment to inspection complete', color: '#4dbd74', perm: 'core.weld_lead_time.weld_lead_time' },
  { to: '/reports/grouping-savings', icon: 'fa-object-group', title: 'Grouping savings', desc: 'Cost savings from inspection grouping vs individual testing', color: '#4dbd74', perm: 'core.grouping_savings.grouping_savings' },
]

function readFavorites() {
  const match = document.cookie.split('; ').find(c => c.startsWith(COOKIE_KEY + '='))
  if (!match) return []
  try { return JSON.parse(decodeURIComponent(match.split('=')[1])) } catch (e) { return [] }
}

function writeFavorites(favs) {
  const expires = new Date(Date.now() + 365 * 864e5).toUTCString()
  document.cookie = `${COOKIE_KEY}=${encodeURIComponent(JSON.stringify(favs))}; expires=${expires}; path=/`
}

export default class ReportsList extends Component {
  constructor(props) {
    super(props)
    this.state = { filter: '', favorites: readFavorites() }
  }

  toggleFavorite(e, to) {
    e.preventDefault()
    e.stopPropagation()
    this.setState(s => {
      const favs = s.favorites.includes(to)
        ? s.favorites.filter(f => f !== to)
        : [...s.favorites, to]
      writeFavorites(favs)
      return { favorites: favs }
    })
  }

  render() {
    const { filter, favorites } = this.state
    const visible = reports
      .filter(r => !r.perm || getUserPermissions(r.perm))
      .filter(r => !filter || r.title.toLowerCase().includes(filter.toLowerCase()))

    const favReports = visible.filter(r => favorites.includes(r.to))
    const otherReports = visible.filter(r => !favorites.includes(r.to))

    const grid = (items) => (
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '16px' }}>
        {items.map(r => {
          const isFav = favorites.includes(r.to)
          return (
            <Link key={r.to} to={r.to} style={{ textDecoration: 'none', position: 'relative' }}>
              <div
                style={{
                  background: '#fff', borderRadius: '10px', padding: '20px 24px',
                  display: 'flex', alignItems: 'flex-start', gap: '16px',
                  boxShadow: '0 1px 4px rgba(0,0,0,0.08)', border: '1px solid #e8eaed',
                  transition: 'box-shadow 0.15s, transform 0.15s', cursor: 'pointer',
                }}
                onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.13)'; e.currentTarget.style.transform = 'translateY(-2px)' }}
                onMouseLeave={e => { e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.08)'; e.currentTarget.style.transform = 'translateY(0)' }}
              >
                <div style={{
                  width: '44px', height: '44px', borderRadius: '10px',
                  background: r.color + '18', display: 'flex', alignItems: 'center',
                  justifyContent: 'center', flexShrink: 0,
                }}>
                  <i className={`fa ${r.icon}`} style={{ fontSize: '18px', color: r.color }} />
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: '14px', color: '#2f353a', marginBottom: '4px' }}>{r.title}</div>
                  <div style={{ fontSize: '12px', color: '#73818f', lineHeight: '1.4' }}>{r.desc}</div>
                </div>
                <i
                  className={`fa ${isFav ? 'fa-star' : 'fa-star-o'}`}
                  onClick={e => this.toggleFavorite(e, r.to)}
                  style={{ fontSize: '16px', color: isFav ? '#ffc107' : '#c8ced3', cursor: 'pointer', flexShrink: 0, marginTop: '2px' }}
                />
              </div>
            </Link>
          )
        })}
      </div>
    )

    return (
      <div className="animated fadeIn" style={{ padding: '24px' }}>
        <h4 style={{ marginBottom: '16px', fontWeight: 700, color: '#2f353a' }}>Reports</h4>
        <input
          type="text"
          placeholder="Search reports..."
          value={filter}
          onChange={e => this.setState({ filter: e.target.value })}
          style={{
            marginBottom: '24px', width: '300px', padding: '8px 14px',
            borderRadius: '8px', border: '1px solid #e8eaed', fontSize: '13px',
            outline: 'none', display: 'block', boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          }}
        />

        {favReports.length > 0 && (
          <div style={{ marginBottom: '32px' }}>
            <div style={{ fontSize: '11px', fontWeight: 700, color: '#ffc107', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '12px' }}>
              <i className="fa fa-star mr-1" /> Favourites
            </div>
            {grid(favReports)}
          </div>
        )}

        {otherReports.length > 0 && (
          <div>
            {favReports.length > 0 && (
              <div style={{ fontSize: '11px', fontWeight: 700, color: '#73818f', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '12px' }}>
                All reports
              </div>
            )}
            {grid(otherReports)}
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Report/ReportsList.js